/**
 *
 * @param blob
 * @param fileName
 */
export const blobToFile = (blob: Blob, fileName: string): File => {
  return new File([blob], fileName, {type: blob.type});
};
